export const beautifyFalseAnswers = (value: string) => {
    if (!value) {
        return '';
    }

    return value.replace(/[\[\]]/g, '');
};

export const beautifyInfinitives = (value: string) => {
    if (!value) {
        return '';
    }

    try {
        return JSON.parse(value).join(', ');
    } catch (e) {
        return [];
    }
};
